import React, { useEffect, useContext } from 'react';
import { useSearchParams } from "react-router-dom";
import { NavLink } from 'react-router-dom';
import AppContext from '../../AppContext';


const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ')
}


const QuickSightTabs = ({sheets, activeSheet, setActiveSheet, dashboard, loading, dropdowns, initialParams, children}) => {

    const [searchParams, setSearchParams] = useSearchParams();
    // const [activeView, setActiveView] = useState();
    // const [activeSheet,setActiveSheet] = useState()
    const { hideHeader } = useContext(AppContext);

    // const location = useLocation();

    // useEffect(() => {
    //   // console.log(location)
    //     if (tabs?.length >0 && location?.pathname) {
    //         setActiveView(tabs?.filter((y) => y.path === location.pathname)[0]?.view)
    //     }
    // }, [location, tabs])


    useEffect(() => {
        const scrollContainer = document.getElementsByClassName('horizontal-scroll');
        if(scrollContainer?.length > 0) {
            scrollContainer[0].addEventListener('wheel', (e) => {
                e.preventDefault();
                scrollContainer[0].scrollLeft += e.deltaY;
            }, { passive: false });
        }
    }, [])

    const years = Array.from({ length: 26 }, (_, i) => 2026 - i);

  return (
    <div className='w-full flex flex-col '>
      <div className={classNames(hideHeader ? 'top-[0px]' : 'top-[55px]',"block px-6 py-2 sticky  z-10 bg-[#f6f6f6]")}>
        <div className="flex flex-row justify-center">
          {!loading && <nav className="-mb-px flex flex-4 space-x-4 xs:space-x-8 sm:space-x-8 md:space-x-8 lg:space-x-8 overflow-x-scroll hide-scrollbar horizontal-scroll" aria-label="Tabs">
            
            {sheets?.filter((y) => y.Name === 'Overview')?.length > 0 ? <></> :
            <NavLink
                // key={sheets.SheetId}
                to={hideHeader ? '../?header_hide=true&footer_hide=true' : '../'}
                // onClick={() => setActiveSheet(sheets.SheetId)}
                className={classNames('border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black hover:no-underline',
                  'group text-lg inline-flex items-center border-b-2 py-4 px-1 font-medium whitespace-nowrap'
                )}
              >
                <span style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}} >Overview</span>
              </NavLink>
            }
            
            {sheets.map((sheets) => (
              <button
                key={sheets.SheetId}
                onClick={() => setActiveSheet(sheets.SheetId)}
                className={classNames(
                  sheets.SheetId === activeSheet
                    ? 'border-[#FBCD44] text-black'
                    : 'border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black',
                  'group text-lg inline-flex items-center border-b-2 py-4 px-1 font-medium whitespace-nowrap'
                )}
                aria-current={(e) => sheets.SheetId === activeSheet ? 'page' : undefined}
              >
                {/* <sheets.icon
                  className={classNames(
                    sheets.id === activeSheet ? 'text-primary-500' : 'text-gray-400 group-hover:text-primary-500',
                    '-ml-0.5 mr-2 h-5 w-5'
                  )}
                  aria-hidden="true"
                /> */}
                <span style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}} >{sheets.Name}</span>
              </button>
            ))}

            {sheets?.filter((y) => y.Name === 'Stat Lab')?.length > 0 ? <></> :
            <NavLink
                // key={sheets.SheetId}
                to={hideHeader ? '../stat-lab?header_hide=true&footer_hide=true' : '../stat-lab'}
                // onClick={() => setActiveSheet(sheets.SheetId)}
                className={classNames('border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black hover:no-underline',
                  'group text-lg inline-flex items-center border-b-2 py-4 px-1 font-medium whitespace-nowrap'
                )}
              >
                <span style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}} >Stat Lab</span>
              </NavLink>
            }

            {dropdowns?.includes('year') && <div className=" content-center flex flex-col leading-tight self-end">
              <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  YEAR
                </span>
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'DraftYear2')?.length >0 ? initialParams?.filter((y) => y?.Name === 'DraftYear2')[0]?.Values[0] : 'All Records'}
                className="w-28 sm:w-36 md:w-36 lg:w-36 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                onChange={(x) => {
                  // console.log(x?.currentTarget?.value); 
                  // setSearchParams({year: x?.currentTarget?.value}); 
                  const next = new URLSearchParams(searchParams);
                  next.set("year", x?.currentTarget?.value);
                  setSearchParams(next);
                  // dashboard?.setParameters([{"Name":"DraftYear2","Values":[x?.currentTarget?.value]}])
                }}
              >
                <option value={'All Records'}>
                    All Records
                  </option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>}


             {dropdowns?.includes('position') && <div className="content-center flex flex-col leading-tight self-end">
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  POSITION
                </span>
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'PositionSelect')?.length >0 ? initialParams?.filter((y) => y?.Name === 'PositionSelect')[0]?.Values[0] :'All Positions'}
                className="w-32 sm:w-40 md:w-40 lg:w-40 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                onChange={(x) => {
                  // console.log(x); 
                  // setSearchParams({position: x?.currentTarget?.value}); 
                  const next = new URLSearchParams(searchParams);
                  next.set("position", x?.currentTarget?.value);
                  setSearchParams(next);
                  // dashboard?.setParameters([{"Name":"PositionSelect","Values":[x?.target?.value]}])
                }}
              >
                {[{name:'All Positions', value:'All Positions'},{name:'Forward', value:'Forward'},{name:'Guard', value:'Guard'},{name:'Center', value:'Center'}].map((x) => (
                  <option key={x?.value} value={x?.value}>
                    {x?.name}
                  </option>
                ))}
              </select>
            </div>}


             {/* {dropdowns?.includes('statx') && <div className="content-center">
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'DynamicStatA')?.length >0 ? initialParams?.filter((y) => y?.Name === 'DynamicStatA')[0]?.Values[0] :'HEIGHT'}
                className="w-44 sm:w-56 md:w-56 lg:w-56 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent"
                onChange={(x) => {
                  const next = new URLSearchParams(searchParams);
                  next.set("x", x?.target?.value);
                  setSearchParams(next);
                  // dashboard?.setParameters([{"Name":"DynamicStatA","Values":[x?.target?.value]}])
                }}
              >
                {[{'name': 'Hand Length', 'value': 'HAND LENGTH'},
                    {'name': 'Hand Width', 'value': 'HAND WIDTH'},
                    {'name': 'Height', 'value': 'HEIGHT'},
                    {'name': 'Lane Agility Time', 'value': 'LANE AGILITY TIME'},
                    {'name': 'Max Vertical Leap', 'value': 'MAX VERTICAL LEAP'},
                    {'name': 'Shuttle Run', 'value': 'SHUTTLE RUN'},
                    {'name': 'Standing Reach', 'value': 'STANDING REACH'},
                    {'name': 'Standing Vertical Leap', 'value': 'STANDING VERTICAL LEAP'},
                    {'name': 'Three Quarter Sprint', 'value': 'THREE QUARTER SPRINT'},
                    {'name': 'Wingspan', 'value': 'WINGSPAN'},
                    ].map((x) => (
                  <option key={`x${x.name}`} value={x.value}>
                    {x.name}
                  </option>
                ))}
              </select>
            </div>} */}

              {dropdowns?.includes('statx') && <div className="content-center flex flex-col leading-tight self-end">
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  Y-AXIS
                </span>

                <select
                  value={initialParams?.length > 0 && initialParams?.filter((y) => y?.Name === 'DynamicStatA')?.length > 0
                    ? initialParams?.filter((y) => y?.Name === 'DynamicStatA')[0]?.Values[0]
                    : 'HEIGHT'}
                  className="w-44 sm:w-56 md:w-56 lg:w-56 bg-white text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                  onChange={(x) => {
                    const next = new URLSearchParams(searchParams);
                    next.set("x", x?.target?.value);
                    setSearchParams(next);
                  }}
                >
                  {[
                    { name: 'Hand Length', value: 'HAND LENGTH' },
                    { name: 'Hand Width', value: 'HAND WIDTH' },
                    { name: 'Height', value: 'HEIGHT' },
                    { name: 'Lane Agility Time', value: 'LANE AGILITY TIME' },
                    { name: 'Max Vertical Leap', value: 'MAX VERTICAL LEAP' },
                    { name: 'Shuttle Run', value: 'SHUTTLE RUN' },
                    { name: 'Standing Reach', value: 'STANDING REACH' },
                    { name: 'Standing Vertical Leap', value: 'STANDING VERTICAL LEAP' },
                    { name: 'Three Quarter Sprint', value: 'THREE QUARTER SPRINT' },
                    { name: 'Wingspan', value: 'WINGSPAN' },
                  ].map((x) => (
                    <option key={`x${x.name}`} value={x.value}>
                      {x.name}
                    </option>
                  ))}
                </select>
              </div>}



            {dropdowns?.includes('staty') && <div className="content-center flex flex-col leading-tight self-end">
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  X-AXIS
                </span>
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'DynamicStatB')?.length >0 ? initialParams?.filter((y) => y?.Name === 'DynamicStatB')[0]?.Values[0] :'STANDING VERTICAL LEAP'}
                className="w-44 sm:w-56 md:w-56 lg:w-56 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                onChange={(x) => {
                  const next = new URLSearchParams(searchParams);
                  next.set("y", x?.target?.value);
                  setSearchParams(next);
                  // dashboard?.setParameters([{"Name":"DynamicStatB","Values":[x?.target?.value]}])
                }}
              >
                {[{'name': 'Hand Length', 'value': 'HAND LENGTH'},
                    {'name': 'Hand Width', 'value': 'HAND WIDTH'},
                    {'name': 'Height', 'value': 'HEIGHT'},
                    {'name': 'Lane Agility Time', 'value': 'LANE AGILITY TIME'},
                    {'name': 'Max Vertical Leap', 'value': 'MAX VERTICAL LEAP'},
                    {'name': 'Shuttle Run', 'value': 'SHUTTLE RUN'},
                    {'name': 'Standing Reach', 'value': 'STANDING REACH'},
                    {'name': 'Standing Vertical Leap', 'value': 'STANDING VERTICAL LEAP'},
                    {'name': 'Three Quarter Sprint', 'value': 'THREE QUARTER SPRINT'},
                    {'name': 'Wingspan', 'value': 'WINGSPAN'},
                    ].map((x) => (
                  <option key={`y${x.name}`} value={x.value}>
                    {x.name}
                  </option>
                ))}
              </select>
            </div>}


          </nav>}
          {/* <nav className='flex flex-1 justify-end '>
            <button
                onClick={() => {console.log(dashboard); dashboard && dashboard?.toggleBookmarksPane()}}
                className={classNames('border-transparent text-gray-500 hover:border-gray-300 hover:text-primary-700',
                  'group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium'
                )}
                aria-current={(e) => sheets.SheetId === activeSheet ? 'page' : undefined}
              >
                <BookmarkIcon
                  className={classNames('text-gray-400 group-hover:text-primary-500',
                    '-ml-0.5 mr-2 h-5 w-5'
                  )}
                  aria-hidden="true"
                />
            </button>
            <button
                onClick={() => {console.log(dashboard); dashboard && dashboard?.initiatePrint()}}
                className={classNames('border-transparent text-gray-500 hover:border-gray-300 hover:text-primary-700',
                  'group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium'
                )}
                aria-current={(e) => sheets.SheetId === activeSheet ? 'page' : undefined}
              >
                <PrinterIcon
                  className={classNames('text-gray-400 group-hover:text-primary-500',
                    '-ml-0.5 mr-2 h-5 w-5'
                  )}
                  aria-hidden="true"
                />
            </button>
          </nav> */}
        </div>
      </div>
      {children}
    </div>
  )
};

export default QuickSightTabs;